<template>
  <section class="version_record">
    <div class="version-list">
      <van-cell :title="'V'+item.name" is-link :to="'version/details?id='+item.id"  v-for="(item,index) in list" :key="index"/>
    </div>
  </section>
</template>

<script>
  import { getVersion } from '@/api/index'
  let u = navigator.userAgent;
  export default {
    name: 'version',
    data() {
      return {
        list: [],
        load: true,
        type: (u.indexOf('Android') > -1|| u.indexOf('Adr') > -1)?'1':'2',
        instance: null
      }
    },
    created() {
      this.getVersionHistory();
    },
    methods: {
      getVersionHistory(){
        getVersion(this.type).then(response => {
          if(response.data.success){
            this.load = false;
            this.list = response.data.data;
          }else{
            this.instance = this.$toast({
              message: response.data.message,
              duration: 2000
            });
          }
        }).catch(() => {
          this.instance = this.$toast({
            message: '网络连接失败',
            duration: 2000
          });
        });
      }
    },
    beforeDestroy() {
      if(this.instance !== null){
        this.instance.close();
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .version_record{
    .van-cell {
      padding: 16px 0 16px 16px;
      .van-cell__title{
        color: #000;
        opacity: .9;
        font-size: 17px;
        flex: 1;
      }
      .van-cell__right-icon{
        margin-right: 10px;
      }
    }
  }
</style>
